/** Novità pubbliche del sito: le ultime funzioni entrate in servizio, in quattro lingue. */
export const NEWS_VERSIONE = "2.7";

export const NEWS = [
  {
    data: "06/07/2026",
    it: {
      t: "Il personale entra col QR, senza codici da dettare",
      d: "Il titolare mostra un QR (o manda un link) e il suo staff arriva diritto ai nomi e al tastierino: nessuno deve conoscere il codice del locale. Il PIN personale resta obbligatorio e si consegna su WhatsApp, per SMS o copiandolo. Se qualcuno se ne va, un tocco e il vecchio QR non vale più.",
    },
    en: {
      t: "Staff sign in with a QR code, no codes to dictate",
      d: "The owner shows a QR code (or sends a link) and the team lands straight on the name list and keypad: nobody needs to know the venue code. The personal PIN is still required and can be sent by WhatsApp, SMS or copied. When someone leaves, one tap makes the old QR code useless.",
    },
    fr: {
      t: "Le personnel entre avec un QR, sans code à dicter",
      d: "Le patron montre un QR (ou envoie un lien) et l'équipe arrive directement sur la liste des noms et le clavier : personne n'a besoin du code de l'établissement. Le code PIN personnel reste obligatoire et s'envoie par WhatsApp, SMS ou copie. Si quelqu'un part, un geste suffit pour invalider l'ancien QR.",
    },
    de: {
      t: "Das Personal kommt per QR-Code hinein, ohne Codes zu diktieren",
      d: "Der Inhaber zeigt einen QR-Code (oder sendet einen Link) und das Team landet direkt bei der Namensliste und dem Zahlenfeld: niemand muss den Lokalcode kennen. Die persönliche PIN bleibt Pflicht und wird per WhatsApp, SMS oder Kopie übergeben. Verlässt jemand das Team, macht ein Tipp den alten QR-Code ungültig.",
    },
  },
  {
    data: "06/07/2026",
    it: {
      t: "Si entra solo nel proprio turno, se lo decidi tu",
      d: "Indichi l'orario di turno sulla scheda della persona e accendi il blocco: fuori da quell'orario non si entra, con venti minuti di tolleranza. Ferie, malattia e riposo bloccano già l'accesso. Titolare e direttore entrano sempre.",
    },
    en: {
      t: "Access only during their own shift, if you decide so",
      d: "Set the shift hours on each person's card and turn the lock on: outside those hours nobody signs in, with twenty minutes of tolerance. Holiday, sick leave and day off already block access. Owner and floor manager always get in.",
    },
    fr: {
      t: "On entre seulement pendant son service, si vous le décidez",
      d: "Indiquez les horaires sur la fiche de chaque personne et activez le verrou : en dehors de ces heures, pas d'accès, avec vingt minutes de tolérance. Congés, maladie et repos bloquent déjà l'accès. Le patron et le directeur de salle entrent toujours.",
    },
    de: {
      t: "Zugang nur während der eigenen Schicht, wenn du es willst",
      d: "Trage die Schichtzeiten auf der Karte jeder Person ein und schalte die Sperre ein: außerhalb dieser Zeiten kommt niemand hinein, mit zwanzig Minuten Toleranz. Urlaub, Krankheit und freier Tag sperren bereits. Inhaber und Serviceleitung kommen immer hinein.",
    },
  },
  {
    data: "06/07/2026",
    it: {
      t: "Il cliente ti chiama dal tavolo col QR",
      d: "Inquadra il QR, legge il menu aggiornato e con un tocco chiede il cameriere, il conto o acqua e pane. La richiesta arriva in sala col numero del tavolo, con campanella e voce. Decidi tu a chi arriva e quante volte un tavolo può chiamare.",
    },
    en: {
      t: "Guests call you from the table with a QR code",
      d: "They scan the code, read the up-to-date menu and ask for the waiter, the bill or water and bread with one tap. The request reaches the floor with the table number, with a chime and a voice. You decide who receives it and how often a table may call.",
    },
    fr: {
      t: "Le client vous appelle depuis la table avec un QR",
      d: "Il scanne le code, consulte la carte à jour et demande le serveur, l'addition ou de l'eau et du pain d'un seul geste. La demande arrive en salle avec le numéro de table, avec sonnerie et annonce vocale. Vous choisissez qui la reçoit et combien de fois une table peut appeler.",
    },
    de: {
      t: "Der Gast ruft dich per QR-Code vom Tisch",
      d: "Er scannt den Code, liest die aktuelle Karte und bittet mit einem Tipp um Service, die Rechnung oder Wasser und Brot. Der Ruf erreicht den Service mit der Tischnummer, mit Glocke und Sprachansage. Du entscheidest, wer ihn erhält und wie oft ein Tisch rufen darf.",
    },
  },
  {
    data: "06/07/2026",
    it: {
      t: "Il report della serata ti arriva per email",
      d: "Chiudi la serata e ricevi incassato, incassi per contanti e carta, coperti, scontrino medio, contanti attesi in cassa, differenza dell'ultima conta, sconti e piatti più venduti. Anche a un secondo indirizzo, per il socio o il commercialista.",
    },
    en: {
      t: "The evening report lands in your inbox",
      d: "Close the evening and receive takings, cash and card totals, covers, average ticket, expected cash, the difference from the last count, discounts and best sellers. A second address can be added for a partner or your accountant.",
    },
    fr: {
      t: "Le rapport de la soirée arrive par e-mail",
      d: "À la clôture, vous recevez les recettes, les totaux espèces et carte, les couverts, le ticket moyen, les espèces attendues, l'écart du dernier comptage, les remises et les plats les plus vendus. Une seconde adresse est possible, pour un associé ou le comptable.",
    },
    de: {
      t: "Der Abendbericht kommt per E-Mail",
      d: "Nach dem Abschluss erhältst du Einnahmen, Bar- und Kartenumsatz, Gedecke, Durchschnittsbon, erwarteten Kassenbestand, die Differenz der letzten Zählung, Rabatte und Verkaufsschlager. Eine zweite Adresse für Partner oder Steuerberater ist möglich.",
    },
  },
  {
    data: "06/07/2026",
    it: {
      t: "Nessuno entra nel tuo gestionale senza il tuo «sì»",
      d: "L'assistenza deve chiedere il permesso indicando il motivo: tu autorizzi, l'accesso vale un'ora e si chiude da solo. Nel gestionale resta il registro di chi è entrato, quando e perché: righe che nessuno può cancellare.",
    },
    en: {
      t: "Nobody enters your system without your approval",
      d: "Support must ask for permission and state the reason: you approve, access lasts one hour and closes by itself. Your system keeps the log of who entered, when and why — entries nobody can delete.",
    },
    fr: {
      t: "Personne n'entre dans votre logiciel sans votre accord",
      d: "L'assistance doit demander l'autorisation en indiquant le motif : vous autorisez, l'accès dure une heure et se ferme seul. Le registre conserve qui est entré, quand et pourquoi — des lignes que personne ne peut effacer.",
    },
    de: {
      t: "Niemand betritt dein System ohne deine Freigabe",
      d: "Der Support muss um Erlaubnis bitten und den Grund angeben: du gibst frei, der Zugang gilt eine Stunde und endet von selbst. Das Protokoll zeigt, wer wann und warum eingetreten ist — Einträge, die niemand löschen kann.",
    },
  },
];
